import { useSelectCurrentProfile } from 'src/reducers/user/user_hooks'
import { getMessengerToggle, isMessengerFlagEnabled, isUserMessagable } from './helpers'
import { ActorProfilePreviewFragmentFragment } from '@lopo-tech/lopo-api'

export const useMessenger = (user?: ActorProfilePreviewFragmentFragment) => {
  const currentProfile = useSelectCurrentProfile()
  const enabled = isMessengerFlagEnabled() && isUserMessagable(user || currentProfile)

  return {
    enabled,
    showToggle: getMessengerToggle(currentProfile?.__typename)
  }
}
